import { assign } from 'lodash';
import { createReducer } from '../util';
import {
  UPDATE_CURRENT_KEYWORD,
  UPDATE_CURRENT_SOURCE_PAGE,
  UPDATE_LOADING_PROJECT_CAROUSEL,
  UPDATE_PROJECTS_ITEMS,
  UPDATE_PROJECTS_TOTAL_COUNT,
} from './action';
import type { State } from './type';
import { ProjectItem } from '../../queries/fragments/project';

const initialState: State = {
  loadingProjectsCarousel: true,
  projectsTotalCount: 0,
  projectsItems: [],
  currentKeyword: '',
  currentSourcePage: '',
};

export default createReducer(initialState, {
  [UPDATE_LOADING_PROJECT_CAROUSEL]: function (
    state: State,
    action: { payload: boolean },
  ): State {
    return assign({}, state, { loadingProjectsCarousel: action.payload });
  },
  [UPDATE_PROJECTS_TOTAL_COUNT]: function (
    state: State,
    action: { payload: number },
  ): State {
    return assign({}, state, { projectsTotalCount: action.payload });
  },
  [UPDATE_PROJECTS_ITEMS]: function (
    state: State,
    action: { payload: ProjectItem[] },
  ): State {
    return assign({}, state, { projectsItems: action.payload });
  },
  [UPDATE_CURRENT_SOURCE_PAGE]: function (
    state: State,
    action: { payload: string },
  ): State {
    return assign({}, state, { currentSourcePage: action.payload });
  },
  [UPDATE_CURRENT_KEYWORD]: function (
    state: State,
    action: { payload: string },
  ): State {
    return assign({}, state, { currentKeyword: action.payload });
  },
});
